import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/useAuth";

/**
 * Route guard for authenticated pages. Mirrors digicampusbd's
 * "anyRequest().authenticated()" rule on the frontend side; the backend still
 * enforces this independently (frontend checks are for UX only).
 */
export default function ProtectedRoute({ children, ...rest }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={() => (user ? children : <Redirect to="/login" />)}
    />
  );
}
